export const GET_BRANCHES = 'GET_BRANCHES'
export const GET_BRANCHES_SUCCESS = 'GET_BRANCHES_SUCCESS'
export const GET_BRANCHES_FAILURE = 'GET_BRANCHES_FAILURE'

export const ADD_BRANCH = 'ADD_BRANCH'
export const ADD_BRANCH_SUCCESS = 'ADD_BRANCH_SUCCESS'
export const ADD_BRANCH_FAILURE = 'ADD_BRANCH_FAILURE'
